import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import CouponMiddleware from './CouponMiddleware';
import CJAMiddleware from './CJAMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CouponMiddleware,
    CJAMiddleware,
    MiniPDPAnalyticsMiddleware,
];

export default rootMiddleware;
